import React from 'react'
import { PolicyLayout } from '../../shared/PolicyLayout'
import { P } from '../../shared/P'
import Footer from '../components/Footer'

export default function Privacy() {
  return <>
  <PolicyLayout title="Privacy Policy" icon="🔒" sub="Last updated: January 1, 2025">
  <div className="bg-orange-50 border border-orange-200 rounded-2xl p-5 text-sm text-orange-800 font-medium">Your privacy is our priority. We collect only what we need to serve you and never sell your data to third parties.</div>
  <P title="1. Information We Collect">We collect your name, email, phone, delivery address and order history when you register or place an order. We also collect device info and usage data to improve our service.</P>
  <P title="2. How We Use Your Information">Your data is used to process orders, send updates, personalise your experience and occasionally send promotional offers. You can opt out of marketing at any time.</P>
  <P title="3. Data Sharing">We share your delivery address with our delivery partners only. Payment data is handled by PCI DSS-compliant processors. We never sell personal data.</P>
  <P title="4. Security">We use 256-bit SSL encryption, 2FA for staff, and conduct quarterly security audits. Your payment details are never stored on our servers.</P>
  <P title="5. Your Rights">You can request access, correction or deletion of your data at any time by emailing privacy@gamapafoods.com. We respond within 30 days.</P>
  <P title="6. Contact">Data Protection Officer: privacy@gamapafoods.com · 123 Food Street, Hyderabad, TS 500034</P>
</PolicyLayout>
    <Footer />
  </>
}
